import Link from 'next/link';
import React from 'react';

import { useIsPreOrder } from '../../hooks/useIsPreOrder';
import { PageName } from '../../types/Analytics';
import { GeneratedGetDrawByProductIDsQuery } from '../../types/generated';
import { TrackProductClicked } from '../../utils/analytics';
import { productUrl } from '../../utils/productUrl';
import ProductTileBadge from './ProductTileBadge';
import ProductTileDescription from './ProductTileDescription';
import ProductTileImage from './ProductTileImage';
import ProductTileStatus from './ProductTileStatus';

type Props = {
  eagerLoading?: boolean;
  product: Product;
  draw?: GeneratedGetDrawByProductIDsQuery['getDrawByProductIDs'][number];
  analytics?: Analytics;
};

const ProductTile: React.FC<Props> = ({
  analytics,
  draw,
  eagerLoading = false,
  product,
}) => {
  const href = productUrl(product.full_slug!, product.productType);
  const pid = product.id.split('/').pop();
  const isPreOrder = useIsPreOrder(draw);

  const handleClick = () => {
    if (analytics) {
      TrackProductClicked({
        page: analytics.page as PageName,
        position: analytics.position,
        context: analytics.context,
        id: product.id,
        productTitle: product.title,
        artist: product.artist,
        productType: product.productType,
        releaseDate: product.launchDate!,
        productUrl: href,
        price: parseInt(product.price, 10),
        currencyCode: product.currencyCode,
        editionSize: product.editionSize,
        ProductAvailibity: product.availability,
      });
    }
  };

  return (
    <Link
      className="group"
      data-testid={`product-tile-pid-${pid}`}
      href={href}
      locale={false}
      onClick={() => handleClick()}
      prefetch={false}
    >
      <div className="flex w-full cursor-pointer flex-col space-y-3">
        <div className="relative flex w-full overflow-hidden rounded-sm">
          <div className="absolute left-0 right-0 top-0 z-20 p-3 md:p-4">
            <ProductTileBadge
              isPreOrder={isPreOrder}
              product={product}
              showCollectionBadge
            />
          </div>
          <ProductTileImage eagerLoading={eagerLoading} product={product} />
        </div>
        <div className="flex flex-col space-y-2">
          <ProductTileDescription draw={draw} product={product} />
          <ProductTileStatus isPreOrder={isPreOrder} product={product} />
        </div>
      </div>
    </Link>
  );
};

// eslint-disable-next-line import/no-default-export
export default ProductTile;
